<div class="map-ui
              absolute
              flex flex-col
              max-w-[700px]"
     [style.width.px]="containerWidthPx()">
  <div class="flex flex-row items-center">
    <mat-form-field (click)="$event.stopPropagation()"
                    appearance="fill"
                    class="pac-input">
      <mat-icon matPrefix [class.text-primary]="pacInput.value?.length"
                svgIcon="search"></mat-icon>
      <input matInput appGxInput
             placeholder="Places search"
             type="text"
             (keydown)="onAutocompleteChange()"
             #pacInput
      >
      @if (pacInput.value) {
        <button matSuffix mat-icon-button aria-label="Clear"
                (click)="clearAutocomplete()"
                [class.invisible]="!pacInput.value?.length">
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      }
    </mat-form-field>

    <!--      CV Mode     -->
    <button mat-stroked-button
            (click)="onToggleCvMode()"
            class="h-9 min-w-[98px] px-0"
            [ngClass]="{'bg-green-90': cvButtonActive()}">
      <mat-icon
          class="h-[24px] w-[24px] text-[24px] mr-0 mb-[3px]"
          svgIcon="where_to_vote_outlined">
      </mat-icon>
      <span class="text-[14px]">Validate</span>
    </button>

    <!--      toggle marker size     -->
    <button mat-icon-button
            (click)="onToggleMinimizeMarkers()"
            class="text-neutral-30 mx-2">
      <mat-icon
          class="h-[24px] w-[24px] text-[24px]"
          [svgIcon]="markersMinimized() ? 'maximize_pin' : 'minimize_pin'">
      </mat-icon>
    </button>
  </div>

  @if (cvButtonActive()) {
    <div class="flex flex-row w-full items-center"
    >
      <!--      focus GEOCODED COORDS marker     -->
      <button mat-icon-button
              (click)="onCenterMarker(gMarker())"
              [disabled]="!gMarker()"
              class="mb-2 ml-2">
        <mat-icon
            class="h-[24px] w-[24px] text-[24px] mr-0"
            svgIcon="focus_geocoded_coords">
        </mat-icon>
      </button>
      <!--      focus IMPORTED COORDS marker     -->
      <button mat-icon-button
              (click)="onCenterMarker(iMarker())"
              [disabled]="!iMarker()"
              class="mb-2 ml-2">
        <mat-icon
            class="h-[24px] w-[24px] text-[24px] mr-0"
            svgIcon="focus_imported_coords">
        </mat-icon>
      </button>
      <!--      place/focus CUSTOM COORDS marker     -->
      <button mat-icon-button
              (click)="canPlaceCustomMarker() ? onPlaceCustomMarker() :
                       canFocusCustomMarker() ? onCenterMarker(customMarker()) :
                       null"
              [disabled]="!canPlaceCustomMarker() && !canFocusCustomMarker()"
              class="ml-2 mb-2">
        <mat-icon
            class="h-[24px] w-[24px] text-[24px] mr-0"
            [class]="canPlaceCustomMarker() || canFocusCustomMarker() ?
                            'text-neutral-30' : 'text-neutral-60'"
            [svgIcon]="canFocusCustomMarker() ? 'focus_custom_coords' : 'custom_pin'">
        </mat-icon>
      </button>

      <mat-divider vertical class="mx-1"></mat-divider>

      <div class="flex items-center w-full">
        <mat-checkbox class="mb-2"
                      (change)="onContinueAfterValidationClick($event)"
                      [checked]="continueAfterValidationActive()"
                      [disabled]="!canContinueAfterValidation()">
          Continue after validation
        </mat-checkbox>

        <div class="flex grow"></div>

        <button mat-icon-button
                (click)="onShowHistoryClick()"
                class="mr-2"
                [ngClass]="{ 'bg-green-90': showValidationHistoryActive() }">
          <mat-icon
              class="h-[24px] w-[24px] text-[24px]"
              svgIcon="history">
          </mat-icon>
        </button>
      </div>
    </div>
  }
</div>


